export default "__VITE_ASSET__BBEdo7UZ__"